import { Button, Menu, MenuItem, TextField } from "@mui/material"
import { context } from "../.."
import React from "react"

const numberStyle = {
    paddingLeft: "10px",
}

const labelStyle = {
    fontSize: "13px",
    color: "#00000099"
}


export default function FieldPhone ({formik, field, disabled = false, autoFocus = false}) {

    const label = context.formatLabel(field.label)
    const options = context.getListSet("country_calling_codes", false)
    const valueSplit = formik.values[field.name]?.split(" ", 2)
    const countryCode = valueSplit?.length ? valueSplit[0] : ""
    const remainderNumber = valueSplit?.length > 1 ? formik.values[field.name].replace(`${countryCode} `, "") : ""
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    return (
        <div className={disabled ? "form-field disabled" : "form-field"}>
            {label ? <label htmlFor={field.name} style={labelStyle}>{label}</label> : null}

            <div style={{display: "flex", marginTop: "8px"}}>
                <Button
                    variant="contained"
                    color="info"
                    onClick={e => {
                        setAnchorEl(!anchorEl ? e.currentTarget : null)
                    }}>
                    <b>{countryCode ? countryCode : "Select country"}</b>
                </Button>

                <Menu
                    anchorEl={anchorEl}
                    open={!!anchorEl}
                    onClose={() => setAnchorEl(null)}>
                    <div style={{}}></div>
                    
                    <MenuItem
                        value="+44"
                        onClick={e => {
                            formik.setFieldValue(field.name, `+44 ${remainderNumber}`)
                            setAnchorEl(null)
                        }}>
                        <div style={{display: "grid", gridTemplateColumns: "80px auto"}}>
                            <span style={{minWidth: "100px"}}>+44</span>
                            <span>United Kingdom</span>
                        </div>
                    </MenuItem>

                    <div style={{width: "95%", height: "0.5px", margin: "5px auto", boxSizing: "border-box", background: "grey"}}></div>

                    {Object.keys(options).map((key, i) => (
                        <MenuItem
                            value={key}
                            key={i}
                            onClick={e => {
                                formik.setFieldValue(field.name, `${key} ${remainderNumber}`)
                                setAnchorEl(null)
                            }}>
                            <div style={{display: "grid", gridTemplateColumns: "80px auto"}}>
                                <span style={{minWidth: "100px"}}>{key}</span>
                                <span>{options[key]}</span>
                            </div>
                        </MenuItem>
                    ))}
                </Menu>

                <TextField
                    value={remainderNumber}
                    autoFocus={autoFocus}
                    inputProps={{style: numberStyle}}
                    placeholder="Phone number"
                    error={formik.submitCount && formik.errors[field.name] ? formik.errors[field.name] : false}
                    onChange={e => {
                        formik.setFieldValue(field.name, `${countryCode} ${e.target.value}`)
                    }} />
            </div>

            {field.helpText ? <span className="help-text">{field.helpText}</span> : null}
        </div>
    )
}